var _style, _circle, _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFilterOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u30EC\\u30A4\\u30E4\\u30FC_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "31px",
    height: "31px",
    viewBox: "0 0 31 31",
    style: {
      enableBackground: "new 0 0 31 31"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n\t.st1{clip-path:url(#SVGID_00000058550841510928163090000001832630038065305735_);}\r\n\t.st2{fill:#AFB1B8;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "\\u6955\\u5186\\u5F62_19",
    className: "st0",
    cx: 15.5,
    cy: 15.5,
    r: 15.5
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_454",
    transform: "translate(7 8)"
  }, /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "SVGID_1_",
    width: 18,
    height: 17.95
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000149368674688342505440000003006622008619414155_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_442",
    style: {
      clipPath: "url(#SVGID_00000149368674688342505440000003006622008619414155_)"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "\\u30D1\\u30B9_287",
    className: "st2",
    d: "M7.88,17.95c-0.61,0.01-1.11-0.47-1.12-1.08c0-0.01,0-0.03,0-0.04V10.1L0.25,1.8 C-0.03,1.47-0.08,1,0.12,0.62C0.3,0.22,0.71-0.03,1.15,0h15.71c0.44-0.03,0.85,0.22,1.02,0.62c0.2,0.38,0.15,0.85-0.13,1.18 l-6.51,8.3v6.73c0.01,0.61-0.47,1.11-1.08,1.12c-0.01,0-0.03,0-0.04,0L7.88,17.95z M9,9.31l5.56-7.07H3.45L9,9.31z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFilterOff);
export default __webpack_public_path__ + "static/media/ico_filter_off.27e299021d18339200ceb49e85117ec1.svg";
export { ForwardRef as ReactComponent };